/**
 * Branded types for units
 */

import type { Float } from "./Brand"

/**
 * Unix timestamp (seconds since epoch)
 */
export type Time = Float<"Time">

/**
 * Size in bytes
 */
export type Bytes = Float<"Bytes", "i64">
